import type { CustomField } from '../../groups/types';
import { ITEM_SYSTEM_FIELDS, type ItemTypeSystemFieldsVisibility } from '../types';

interface GetItemFieldsParams {
	systemFieldsVisibility?: ItemTypeSystemFieldsVisibility;
	hasDepreciationPermission?: boolean;
	customFields?: CustomField[];
	currency?: string | null;
}

export type ItemFieldEntry = Partial<Omit<CustomField, 'id' | 'name' | 'kind' | 'allowedComparators'>> &
	Pick<CustomField, 'id' | 'name'> & {
		kind: string;
		allowedComparators?: readonly string[];
		excludeFromFilters?: boolean;
	};

export const getItemFields = ({
	systemFieldsVisibility,
	hasDepreciationPermission = true,
	customFields = [],
	currency = null,
}: GetItemFieldsParams): ItemFieldEntry[] => {
	let systemFields = [...ITEM_SYSTEM_FIELDS];

	if (systemFieldsVisibility) {
		systemFields = systemFields.filter((field) => {
			if (field.id === 'brand') return systemFieldsVisibility.brand;
			if (field.id === 'model') return systemFieldsVisibility.model;
			if (field.id === 'warrantyDate') return systemFieldsVisibility.warranty_date;
			if (field.id === 'purchaseDate') return systemFieldsVisibility.purchase_date;
			if (field.id === 'purchasePrice') return systemFieldsVisibility.purchase_price;
			if (field.id === 'residualValue') return systemFieldsVisibility.residual_value;
			return true;
		});
	}

	if (!hasDepreciationPermission) {
		systemFields = systemFields.filter((field) => field.id !== 'depreciatedValue');
	}

	return [
		...systemFields.map((field) => ({
			...field,
			unit: 'editor' in field && field.editor === 'currency' ? currency : null,
		})),
		...customFields.map((field) => ({ ...field, id: `fields.${field.name}` })),
	];
};
